import React, {useState} from 'react';
import {isWidthUp, makeStyles, useMediaQuery, useTheme, withWidth} from '@material-ui/core';
import MainToolbar from "./MainToolbar";
import Drawer from "@material-ui/core/Drawer";
import GeofencesList from "./GeofencesList";
import ContainerDimensions from "react-container-dimensions";
import MapGoogle from "./mapGoogle/MapGoogle";
import CurrentLocationMapGoogle from "./mapGoogle/CurrentLocationMapGoogle";
import {useDispatch, useSelector} from "react-redux";
import {geofencesActions} from "./store";
import GeofenceEditGoogleMap from "./mapGoogle/GeofenceEditGoogleMap";
import GeofenceMapGoogle from "./mapGoogle/GeofenceMapGoogle";
import {FormDialog} from "./map/FormDialog";
import ButtonsHistory from "./shared/ButtonsHistory";
import {cyberStyles} from "./cssShared/cyberTheme";
import ButtonsHistoryMobile from "./shared/ButtonsHistoryMobile";

const useStyles = makeStyles(theme => ({
    ...cyberStyles(theme),
    buttonsHistory: {
        marginTop: 'auto',
        paddingBottom: 0,
        marginBottom: 0,
    },
}));

const GeofencesGoogleMap = ({ width }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const subadminEnabled = useSelector(state => state.session.user && state.session.user.subadmin)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [open, setOpen] = React.useState(false);
    const [newItem, setNewItem] = useState({ name: '', area: ''});

    const refreshGeofences = async () => {
        const response = await fetch('/api/geofences');
        if (response.ok) {
            let res = await response.json();
            dispatch(geofencesActions.refresh(res));
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className={classes.geofenceRoot}>
            {!isMobile && <MainToolbar/>}

            <div className={classes.geofenceContent}>
                <Drawer
                    anchor={isWidthUp('sm', width) ? 'left' : 'bottom'}
                    variant='permanent'
                    classes={{ paper: classes.geofenceDrawerPaper }}>
                    <GeofencesList />
                    {!isMobile ?
                        <div className={classes.buttonsHistory}>
                            <ButtonsHistory/>
                        </div>
                        :
                        <div className={classes.buttonsHistory}>
                            <ButtonsHistoryMobile/>
                        </div>
                    }
                </Drawer>
                <div className={classes.mapContainer}>
                    <ContainerDimensions>
                        <MapGoogle>
                            <CurrentLocationMapGoogle />
                            <GeofenceMapGoogle />
                            {subadminEnabled && (
                                <GeofenceEditGoogleMap
                                    refreshGeofences={refreshGeofences}
                                    newItem={newItem}
                                    setNewItem={setNewItem}
                                    handleClickOpen={handleClickOpen}
                                />
                            )}
                        </MapGoogle>
                    </ContainerDimensions>
                </div>
                <FormDialog refreshGeofences={refreshGeofences} newItem={newItem} setNewItem={setNewItem} open={open} handleClose={handleClose}/>
            </div>
        </div>
    );
}

export default withWidth()(GeofencesGoogleMap);